import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { BackButton } from "../lib/nav";
import { useAuth, homeForRole } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { Logo } from "../components/Brand";
import { toast } from "sonner";

export default function Register() {
  const { register, user, loading } = useAuth();
  const nav = useNavigate();
  const [role, setRole] = useState("USER");
  const [f, setF] = useState({ name: "", email: "", password: "", stage_name: "", bio: "", location: "", genres: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const payload = { name: f.name, email: f.email, password: f.password, role };
      if (role === "DJ") Object.assign(payload, { stage_name: f.stage_name || f.name, bio: f.bio, location: f.location, genres: f.genres.split(",").map((x) => x.trim()).filter(Boolean) });
      if (role === "ORGANIZER") Object.assign(payload, { stage_name: f.stage_name || f.name, bio: f.bio, location: f.location });
      const u = await register(payload);
      toast.success(role === "DJ" ? "DJ application submitted — pending approval" : `Welcome, ${u.name}`);
      nav(homeForRole(u.role), { replace: true });
    } catch (ex) { setErr(formatApiError(ex.response?.data?.detail) || ex.message); }
    setBusy(false);
  };

  if (loading) return null;
  if (user) return <Navigate to={homeForRole(user.role)} replace />;

  return (
    <div className="min-h-screen grain flex items-center justify-center px-4 py-10 bg-[#0A0A0C]">
      <div className="w-full max-w-md fade-up">
        <div className="flex justify-center mb-6"><Logo size={56} /></div>
        <div className="card-copper rounded-2xl p-8">
          <BackButton fallback="/" className="mb-4" />
          <h1 className="font-display text-2xl font-bold uppercase">Join Rav3.Labs</h1>
          <div className="flex gap-2 mt-4">
            {["USER", "DJ", "ORGANIZER"].map((r) => (
              <button key={r} data-testid={`role-${r}`} onClick={() => setRole(r)} className={`flex-1 mono-label rounded-lg py-2.5 border ${role === r ? "border-[#E8552A] text-[#E8552A] bg-[#E8552A]/10" : "border-[#27272A] text-[#A1A1AA]"}`}>
                {r === "USER" ? "LISTENER" : r === "DJ" ? "DJ / ARTIST" : "ORGANIZER"}
              </button>
            ))}
          </div>
          <form onSubmit={submit} className="space-y-4 mt-5">
            <input data-testid="reg-name" required value={f.name} onChange={set("name")} placeholder="Full name" className="w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]" />
            <input data-testid="reg-email" type="email" required value={f.email} onChange={set("email")} placeholder="Email" className="w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]" />
            <input data-testid="reg-password" type="password" required value={f.password} onChange={set("password")} placeholder="Password (min 6 chars)" className="w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]" />
            {role === "DJ" && (
              <>
                <input data-testid="reg-stage" value={f.stage_name} onChange={set("stage_name")} placeholder="DJ / stage name" className="w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]" />
                <input data-testid="reg-location" value={f.location} onChange={set("location")} placeholder="Location" className="w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]" />
                <input data-testid="reg-genres" value={f.genres} onChange={set("genres")} placeholder="Genres (comma separated)" className="w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]" />
                <textarea data-testid="reg-bio" value={f.bio} onChange={set("bio")} placeholder="Short bio" rows={2} className="w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]" />
              </>
            )}
            {err && <p data-testid="reg-error" className="text-sm text-[#ef4444]">{err}</p>}
            <button data-testid="reg-submit" disabled={busy} className="w-full copper-btn rounded-lg py-3 mono-label disabled:opacity-60">{busy ? "CREATING…" : "CREATE ACCOUNT"}</button>
          </form>
          <p className="text-sm text-[#71717A] text-center mt-6">Already have an account? <Link to="/login" className="text-[#E8552A] hover:underline">Sign in</Link></p>
        </div>
      </div>
    </div>
  );
}
